import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEnExtra from '@angular/common/locales/extra/en';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeItExtra from '@angular/common/locales/extra/it';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

registerLocaleData(localeDe, 'de', localeDeExtra);
registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeEn, 'en', localeEnExtra);
registerLocaleData(localeEn, 'en-US', localeEnExtra);
registerLocaleData(localeEn, 'en-GB', localeEnExtra);
registerLocaleData(localeIt, 'it', localeItExtra);
registerLocaleData(localeIt, 'it-IT', localeItExtra);
registerLocaleData(localeFr, 'fr', localeFrExtra);
registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

const options = {
    preserveWhitespaces: !environment.production,
};

if (environment.production) {
    enableProdMode();
}

platformBrowser()
    .bootstrapModule(AppModule, options)
    .catch((err) => console.log(err));
